
import { notification } from "antd";
import { myEventActions } from ".";
import {
  addBookingService,
  confirmPaymentService,
  getAllEventService,
  getOneBookingService,
  getOneEventService,
  getOneInvoiceService,
  updateEventService,
} from "./services";


//event
export const getAllEventsAction = (query) => {
  return async (dispatch) => {
    try {
      dispatch(myEventActions.setIsFetching(true));
      const res = await getAllEventService(query);
      if (res?.status === 200) {
        dispatch(myEventActions.setAll(res));
        dispatch(myEventActions.setIsFetching(false));
      }
      dispatch(myEventActions.setIsFetching(false));
    } catch (err) {
      console.error(err);
    }
  };
};

export const getOneEventAction = (itemId) => {
  return async (dispatch) => {
    try {
      dispatch(myEventActions.setIsGetEvent(true));
      const res = await getOneEventService(itemId);
      if (res?.status === 200) {
        dispatch(myEventActions.setSelected(res?.data));
        dispatch(myEventActions.setIsGetEvent(false));
      }
      dispatch(myEventActions.setIsGetEvent(false));
    } catch (err) {
      console.error(err);
    }
  };
};

export const updateEventAction = (itemId, data) => {
  return async (dispatch) => {
    try {
      dispatch(myEventActions.setIsUpdating(true));
      const res = await updateEventService(itemId, data);
      if (res?.status === 200) {
        const resAll = await getAllEventService("?");
        dispatch(myEventActions.setAll(resAll));
        dispatch(myEventActions.setUpdated(res?.data));
        dispatch(myEventActions.setIsUpdating(false));
        return { type: true, data: res?.data }
      }
      dispatch(myEventActions.setIsUpdating(false));
      return { type: false, data: {} }
    } catch (err) {
      console.error(err);
    }
  };
};

// booking
export const addBookingAction = (

  data
) => {
  return async (dispatch) => {
    try {
      dispatch(myEventActions.setIsCreatingBooking(true));
      const res = await addBookingService(data);
      if (res?.status === 201) {
        dispatch(myEventActions.setNew(res?.data));
        dispatch(myEventActions.setIsCreatingBooking(false));
        return { type: true, data: res?.data }
      } else if (res?.response?.status === 400) {
        dispatch(myEventActions.setIsCreatingBooking(false));
        notification.error({ message: "Something went wrong. Please contact support." })
        return { type: false, data: {} }
      }
      dispatch(myEventActions.setIsCreatingBooking(false));
      return { type: false, data: {} }
    } catch (err) {
      console.error(err);
    }
  };
};

export const getOneBookingAction = (itemId) => {
  return async (dispatch) => {
    try {
      dispatch(myEventActions.setIsFetching(true));
      const res = await getOneBookingService(itemId);
      if (res?.status === 200) {
        dispatch(myEventActions.setSelectedBooking(res?.data));
        dispatch(myEventActions.setIsFetching(false));
      }
      dispatch(myEventActions.setIsFetching(false));
    } catch (err) {
      console.error(err);
    }
  };
};

//payment
export const confirmPaymentAction = (
  data
) => {
  return async (dispatch) => {
    try {
      dispatch(myEventActions.setIsConfirmingPayment(true));
      const res = await confirmPaymentService(data);
      if (res?.status === 201) {
        dispatch(myEventActions.setIsConfirmingPayment(false));
        dispatch(myEventActions.setCompletedPayment(res?.data));
        return { type: true, data: res?.data }
      }
      dispatch(myEventActions.setIsConfirmingPayment(false));
      return { type: false, data: {} }
    } catch (err) {
      console.error(err);
    }
  };
};

export const getOneInvoiceAction = (itemId) => {
  return async (dispatch) => {
    try {
      dispatch(myEventActions.setIsgettingInvoice(true));
      const res = await getOneInvoiceService(itemId);
      if (res?.status === 200) {
        dispatch(myEventActions.setSelectedInvoice(res?.data));
        dispatch(myEventActions.setIsgettingInvoice(false));
      }
      dispatch(myEventActions.setIsgettingInvoice(false));
    } catch (err) {
      console.error(err);
    }
  };
};